/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .directive('accTruncate', ['$timeout', 'DATA_TABLE_EVENTS', 'escapeHTMLFilter', function($timeout, DATA_TABLE_EVENTS, escapeHTMLFilter){
        /**
         * (!) Don't use this directive in case you need
         * to truncate the end of string. Use text-overflow
         * css property instead
         */
        return function($scope, $element, $attrs) {
            var options = {
                ellipsis: $attrs['accTruncateEllipsis'] || '…',
                position: $attrs['accTruncatePosition'] || 'middle' // start, middle, end
            };
            var truncated = null;

            var updateTruncation = function(value, delay) {
                delay = angular.isNumber(delay) ? delay : 150;

                if (value) {
                    value = escapeHTMLFilter(value);
                }

                $timeout(function() {
                    truncated.update(value);
                    truncated.collapse();
                }, delay);
            };

            var unsubscribeWindowResize = $scope.$on('windowResize', function() {
                updateTruncation();
            });

            var unsubscribeDataTableSetWidth = $scope.$on(DATA_TABLE_EVENTS.SET_WIDTH, function() {
                updateTruncation(undefined, 0);
            });

            var unwatchNodeNameUpdate = $scope.$watch('node.name', function(newValue, oldValue) {
                if (oldValue !== newValue) {
                    updateTruncation(newValue);
                }
            });

            $element.on('$destroy', function() {
                unsubscribeWindowResize();
                unwatchNodeNameUpdate();
                unsubscribeDataTableSetWidth();
            });

            $timeout(function() {
                truncated = new Truncate($element.get(0), options);
            });
        };
    }]);
